import { queryOptions, useQuery } from '@tanstack/react-query'
import { InferRequestType } from 'hono'

import { apiClient, formatClientResponse } from '@/apiClient.ts'

type FindAttributesArgs = InferRequestType<
  typeof apiClient.attributes.$get
>['query']

export const findAttributesQueryOptions = (args?: FindAttributesArgs) =>
  queryOptions({
    queryKey: ['attributes', args],
    queryFn: () =>
      apiClient.attributes
        .$get({ query: args ?? {} })
        .then((r) => formatClientResponse(r)),
  })

export const useFindAttributes = (
  args?: FindAttributesArgs,
  options?: Partial<ReturnType<typeof findAttributesQueryOptions>>
) =>
  useQuery({
    ...findAttributesQueryOptions(args),
    ...options,
  })
